<template>
  <spinner v-if="showSpinner" fullScreen />
  <section v-else>
    <h5 class="card-title">Widget Config</h5>
    <hr class="mt-0 mb-5">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="form-group row">
          <label class="col-sm-4 text-right col-form-label">Title</label>
          <div class="col-md-8">
            <b-form-input v-model="widget.title" type="text" class="form-control" placeholder="type here"></b-form-input>
            <div class="pb-1">
              <span class="hint"><i class="mdi mdi-information-outline"></i> goes just above the input box when in Floating Bottom position </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 text-right col-form-label">Sub title</label>
          <div class="col-md-8">
            <b-form-input v-model="widget.subTitle" type="text" class="form-control" placeholder="type here"></b-form-input>
            <div class="pb-1">
              <span class="hint"><i class="mdi mdi-information-outline"></i> goes just above the input box and below the Title </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 text-right col-form-label">Input Prompt</label>
          <div class="col-md-8">
            <b-form-input v-model="widget.inputPrompt" type="text" class="form-control" placeholder="example: What are your needs?"></b-form-input>
            <div class="pb-1">
              <span class="hint"><i class="mdi mdi-information-outline"></i> engage your visitor with a question</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-group row">
          <label class="col-sm-4 text-right col-form-label">Position</label>
          <div class="col-md-8">
            <b-form-select v-model="widget.position" :options="positions" class="form-control"></b-form-select>
            <div class="pb-1">
              <span class="hint"><i class="mdi mdi-information-outline"></i> affect widget initial position on a screen</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 text-right col-form-label">Color Theme</label>
          <div class="col-md-8">
            <b-form-select v-model="widget.theme" :options="themes" class="form-control"></b-form-select>
            <div class="pb-1">
              <span class="hint"><i class="mdi mdi-information-outline"></i> affects look of the input box in Floating Bottom position </span>
            </div>
          </div>
        </div>
        <div class="form-group row" v-if="isUserAdmin">
          <label class="col-sm-4 text-right col-form-label">Mode</label>
          <div class="col-md-8">
            <b-form-select v-model="mode" :options="modes" class="form-control"></b-form-select>
            <div class="pb-1">
              <span class="hint"><i class="mdi mdi-information-outline"></i> how to react to visitor input </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h5 class="card-title mt-5">Chat Config</h5>
    <hr class="mt-0 mb-5">
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Greeting message</label>
      <div class="col-md-10">
        <b-form-input v-model="widget.greeting" type="text" class="form-control" placeholder="example: Hi, my name is {name}.  I can help you to with your request"></b-form-input>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> the first message visitors will see at the start of their chat session; use "{name}" to insert live agent's name for a personal touch. </span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Thank you message</label>
      <div class="col-md-10">
        <b-form-input v-model="widget.thanksMessage" type="text" class="form-control" placeholder="example: Thank you! We will be contacting you within the next 10 minutes"></b-form-input>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> text visitors will see at the end of their chat session </span>
        </div>
      </div>
    </div>
    <!---->
    <h5 class="card-title mt-5">Live Agent Button Config</h5>
    <hr class="mt-0 mb-5">
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Long Button Text</label>
      <div class="col-md-10">
        <b-form-input v-model="agent.longText" type="text" class="form-control" placeholder="example: Click to Chat" maxlength="30"></b-form-input>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> the button label visitors will see on desktop and tables devices</span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Short Button Text</label>
      <div class="col-md-10">
        <b-form-input v-model="agent.shortText" type="text" class="form-control" placeholder="example: Chat" maxlength="10"></b-form-input>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> the button label visitors will see on mobile devices </span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Position</label>
      <div class="col-md-10">
        <b-form-select v-model="agent.position" :options="agentButtonPosition" class="form-control"></b-form-select>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label"></label>
      <div class="col-md-10">
        <div class="custom-control custom-checkbox pb-3">
          <input type="checkbox" class="custom-control-input" id="liveAgentCheck" v-model="agent.enabled">
          <label class="custom-control-label" for="liveAgentCheck"> {{(agent.enabled) ? 'Enabled' : 'Disabled'}} </label>
        </div>
      </div>
    </div>
    <!---->
    <h5 class="card-title mt-5">Call Button Config</h5>
    <hr class="mt-0 mb-5">
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Phone Number</label>
      <div class="col-md-10">
        <input id="phone"
               name="phone"
               ref="phone"
               v-model="phone.phone"
               type="tel"
               class="form-control"
               v-mask="'(###) ###-####'"
               placeholder="(999) 999-9999"
               v-validate="{ regex: /^\(\d{3}\) \d{3}-\d{4}$/ }"
               :class="{'is-invalid': errors.has('phone')}"
        />
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> the phone number visitors can use for click to call</span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Short Button Text</label>
      <div class="col-md-10">
        <b-form-input v-model="phone.shortText" type="text" class="form-control" placeholder="example: Call" maxlength="10"></b-form-input>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> the button label visitors will see on mobile devices </span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Position</label>
      <div class="col-md-10">
        <b-form-select v-model="phone.position" :options="callButtonPosition" class="form-control"></b-form-select>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label"></label>
      <div class="col-md-10">
        <div class="custom-control custom-checkbox pb-3">
          <input type="checkbox" class="custom-control-input" id="phoneCheck" v-model="phone.enabled">
          <label class="custom-control-label" for="phoneCheck"> {{(phone.enabled) ? 'Enabled' : 'Disabled'}} </label>
        </div>
      </div>
    </div>
    <!---->
    <h5 class="card-title mt-5">Exit Offer Config</h5>
    <hr class="mt-0 mb-5">
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Offer Title</label>
      <div class="col-md-10">
        <b-form-input v-model.trim="exitOffer.title" type="text" class="form-control" placeholder="example: Surprise!" maxlength="50"></b-form-input>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> the title visitors will see when offer is presented</span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Offer Text</label>
      <div class="col-md-10">
        <b-form-input v-model.trim="exitOffer.text" type="text" class="form-control" placeholder="example: You've unlocked our secret sale." maxlength="140"></b-form-input>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> the main message visitors will see when offer is presented</span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Button Text</label>
      <div class="col-md-10">
        <b-form-input v-model.trim="exitOffer.button" type="text" class="form-control" placeholder="example: Get it Now" maxlength="30"></b-form-input>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> the text of the submit button</span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label">Field</label>
      <div class="col-md-10">
        <b-form-select
          v-model.lazy="exitOffer.field"
          :options="questions"
          text-field="fieldName"
          value-field="id"
          name="fieldName"
          class="form-control"
          v-if="questions.length"
        ></b-form-select>
        <div class="pb-1">
          <span class="hint"><i class="mdi mdi-information-outline"></i> select the field name user need to populate in response to the offer.</span>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 text-right col-form-label"></label>
      <div class="col-md-10">
        <div class="custom-control custom-checkbox pb-3">
          <input type="checkbox" class="custom-control-input" id="exitOfferEnabled" v-model="exitOffer.enabled">
          <label class="custom-control-label" for="exitOfferEnabled"> {{(exitOffer.enabled) ? 'Enabled' : 'Disabled'}} </label>
        </div>
      </div>
    </div>
    <!---->
    <div class="mt-5">
      <button class="btn btn-info" @click="update">
        Save Widget Config
      </button>
    </div>
  </section>
</template>
<script>
import libphonenumber from 'google-libphonenumber';
import Spinner from '@/components/Spinner';
import { mapGetters, mapActions } from 'vuex';
import ConfirmButton from '@/components/ConfirmButton';
import QuestionsCompact from '@/graphql/Questions/QuestionsCompact.gql';

const PNF = libphonenumber.PhoneNumberFormat;
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

export default {
  components: {
    Spinner,
    ConfirmButton,
  },
  props: {
    showSpinner: Boolean
  },
  data() {
    return {
      questions: [],
    }
  },
  computed: {
    ...mapGetters(['campaign', 'isUserAdmin']),
    campaignId() {
      return (this.campaign) ? this.campaign.id : null;
    },
    widget() {
      return (this.campaign) ? this.campaign.widget : {};
    },
    agent() {
      return (this.campaign && this.campaign.widget && this.campaign.widget.agent) ? this.campaign.widget.agent : {
        longText : 'Click to Chat',
        shortText: 'Chat',
        position: 'top',
        enabled: false
      };
    },
    phone() {
      return (this.campaign && this.campaign.widget && this.campaign.widget.phone) ? this.campaign.widget.phone : {
        shortText: 'Call',
        position: 'top',
        enabled: false,
      };
    },
    exitOffer() {
      return (this.campaign && this.campaign.widget && this.campaign.widget.exitOffer) ? this.campaign.widget.exitOffer : {
        title: 'Surprise!',
        text: 'You\'ve unlocked our secret sale.',
        button: 'Get it Now',
        enabled: false,
      };
    },
    mode: {
      get() {
        return (this.widget && this.widget.mode) ? this.widget.mode : 'form';
      },
      set(newValue) {
        if (this.widget) {
          this.widget.mode = newValue;
        }
      },
    },
    themes: () => [
      { value: 'dark', text: 'Dark' },
      { value: 'white', text: 'White' },
      { value: 'blue', text: 'Blue' },
    ],
    positions: () => [
      { value: 'static', text: 'Static' },
      { value: 'floating-bottom', text: 'Floating Bottom' },
    ],
    modes: () => [
      { value: 'form', text: 'Step-by-Step Form' },
      { value: 'chat', text: 'Live Agent Chat' },
    ],
    agentButtonPosition: () =>  [
      { value: 'top', text: 'Top Right' },
      { value: 'bottom', text: 'Bottom Right' },
    ],
    callButtonPosition: () =>  [
      { value: 'top', text: 'Top Left' },
      { value: 'bottom', text: 'Bottom Left' },
    ]
  },
  methods: {
    ...mapActions(['updateWidget']),
    async update() {
      try {
        if (this.phone.phone) {
          const phoneNumber =  phoneUtil.parseAndKeepRawInput(this.phone.phone, 'US');
          this.widget.phone = {
            ...this.phone,
            international: phoneUtil.format(phoneNumber, PNF.INTERNATIONAL),
            national: phoneUtil.format(phoneNumber, PNF.INTERNATIONAL),
            e164: phoneUtil.format(phoneNumber, PNF.E164)
          };
        }
        if (this.agent.longText) {
          this.widget.agent = this.agent;
        }
        if (this.exitOffer.text) {
          this.widget.exitOffer = this.exitOffer;
        }
        await this.updateWidget();
        this.$notify({
          group: 'success',
          type: 'success',
          text: 'Saved',
        });
      } catch (e) {
        this.$notify({
          group: 'error',
          type: 'error',
          text: e.message,
        });
      }
    },
  },
  apollo: {
    questions: {
      query: QuestionsCompact,
      fetchPolicy: 'network-only',
      variables() {
        return {
          where: JSON.stringify({ campaignId: +this.campaignId }),
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.questions = data.questions.result.map(({ id, fieldName }) => ({
            id,
            fieldName,
          }));
        }
      },
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Campaigns/Details/WidgetConfig.vue